import { render, staticRenderFns } from "./HandlingStatusBadge.vue?vue&type=template&id=27b7cea8&scoped=true&"
import script from "./HandlingStatusBadge.vue?vue&type=script&lang=js&"
export * from "./HandlingStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b7cea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b7cea8')) {
      api.createRecord('27b7cea8', component.options)
    } else {
      api.reload('27b7cea8', component.options)
    }
    module.hot.accept("./HandlingStatusBadge.vue?vue&type=template&id=27b7cea8&scoped=true&", function () {
      api.rerender('27b7cea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HandlingStatusBadge.vue"
export default component.exports